module.exports = __webpack_public_path__ + "img/120.0aac479c.jpg";